module.exports = __webpack_public_path__ + "media/images/email/share/logo-e3a554b62909f89f0e0ae261dab3505e.jpg";